import React, { Component } from 'react';
import {
    View,
    Share,
    StyleSheet,
    Image,
    Platform,
    TouchableOpacity,
    TouchableWithoutFeedback,
    Dimensions, Text
  
} from 'react-native';
import moment from 'moment';
import { Styles } from './UI-Components';
import Grid from '@material-ui/core/Grid';

// import Icon from 'react-native-vector-icons/FontAwesome';


const { width, height } = Dimensions.get("window");

const shareIcon = require('./../assets/assets_png/share.png')
const bookMark = require('./../assets/assets_png/bookMark.png')
const bookMarked = require('./../assets/assets_png/bookmarked.png')
 

const ArticlesComponent = ({
    navigation, item, index, isBookmarked,
    bookmarkId,
    deleteBookMark,
    addBookmark,
    addBookMarkLoading,
    share,
    fromList
    }) => {
      
    return (
        <TouchableWithoutFeedback
            key={index}
            onPress={() => {
              
                navigation.push(`CurrentAffairs/${item.id}`, {
                    data: item.content,
                    id: index,
                    titleId: item.id,
                    source: item.url,

                })
            }
            }
            
            >
            <div className='current_affairs'>
            <View style={[styles.card_shadow]}>
                <View style={{justifyContent:'space-between', alignItems: 'center', flexDirection: 'row'}}>
                    <View style={{ width: 100, height: 100,}}>
                        <Image source={{ uri: item.url }} style={styles.ImageStyle} />
                    </View>
                    <View style={{ flex: 1,  alignSelf: 'center', }}>
                        {/* <Text style={{color:Styles.primaryColor, fontSize:12,marginLeft:10,marginTop:10}}>Latest news</Text> */}
                        <Text ellipsizeMode="tail" numberOfLines={height > 750 ? 2 : 3} style={styles.currentAffairscontent}>
                            {item.title}
                        </Text>
                        <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: 10 }}>
                            <Text style={{ marginLeft: 10, fontSize: 10, color: '#707070' }}> {moment(item.created_at).format('D MMMM YY')} </Text>                            
                            {/* <Text style={{ marginLeft: 10, fontSize: 10, color: '#707070' }}> {moment(item.created_at).format('D MMM YY')} </Text> */}
                            {/* <Text style={{ marginLeft: 10, fontSize: 10, color: '#707070' }}> 24/07/19 9:45pm </Text> */}
                        </View>
                    </View>
                </View>
                
               {
               
                <TouchableOpacity
                    hitSlop={{
                        top: 8,
                        bottom: 8,
                        left: 8,
                        right: 8
                    }}
                    onPress={() => {                                                               
                        if(isBookmarked){                                                                                              
                            deleteBookMark(bookmarkId);
                        }
                        if(!isBookmarked && !addBookMarkLoading){
                            
                            addBookmark()
                        }
                    }}
                    style={[styles.backButton, {position: 'absolute', top: 10, right: 10}]}
                >
                     <Image 
                     source={isBookmarked ? bookMarked  :  bookMark}
                      style={{width: 32 ,height: 32}}
                    />
                </TouchableOpacity>
                }
                    <TouchableOpacity
                        hitSlop={{
                            top: 8,
                            bottom: 8,
                            left: 8,
                            right: 8
                        }}
                        onPress={share} 
                        style={[styles.backButton, {position: 'absolute', bottom: 10, right: 10}]}
                        >
                        
                        <Image 
                        source={shareIcon}
                        style={{width: 32 ,height: 32}}
                        />
                    </TouchableOpacity>                                                   

            </View>
            </div>
        </TouchableWithoutFeedback>
    )
}


const styles = StyleSheet.create({
    heading: {
        fontSize: 20,
        color: '#222',
        paddingLeft: 10,
        marginVertical: 20,
        // ...Platform.select({
        //     android: {
        //         ...robotoWeights.bold,
        //     },
        //     ios: {
        //         ...sanFranciscoWeights.bold,
        //     },
        // })
    },
    currentAffairsDescription: {
        alignItems: 'center',
        justifyContent: 'center',
        marginHorizontal: 10
    },
    ImageStyle: {
        justifyContent: 'center',
        alignItems: 'center',
        // marginTop: 10,
        width: 100,
        height: 100,
        // maxHeight: 100,
        // resizeMode: 'contain',
        // backgroundColor:Color.imageBgColor,
        borderRadius: 5,        
        alignSelf: 'center',
        marginLeft: 0,
        //borderWidth: 1
        borderTopLeftRadius: 5,
        borderBottomLeftRadius:5,
    },
    currentAffairscontent: {
        // height:70,
        paddingHorizontal: 10,
        // paddingTop: 2,
        textAlign: 'justify',
        width: '85%',
        fontWeight:'bold'
        // borderWidth: 1,
        // marginTop: -5
    },
    card_shadow: {
        marginVertical: 4,
       marginHorizontal: 15,
       borderWidth: 3,
       borderColor: '#fff',
        borderRadius: 15,
        backgroundColor: '#e6edf2',
        // width:  width <=780 ?  '100%' : '48%',

    },
    actions: {
        position: 'absolute',
        bottom: 4,
        right: 8,
        paddingVertical: 4,
        // borderWidth: 1,
        flexDirection: 'row'
    },
    actionIcon: {
        color: 'rgba(0,0,0,0.7)'
    },
    backButton: {        
        borderRadius: 10,
        borderWidth: 3,
        borderColor: '#fff',
        width: 32,
        height: 32,      
        zIndex: 1000,
        justifyContent: 'center',
        alignItems: 'center',
        // elevation: 8
    }
});

export default ArticlesComponent;